import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { Button } from 'src/@/components/ui/button';
import { Label } from 'src/@/components/ui/label';
import Iconify from 'src/components/Iconify';

import { MAKE_DESIGN as d } from '../Make.design';

const ModalAddMake = ({
    openWebhook,
    nome,
    setNome,
    url,
    setUrl,
    isEdit,
    loading,
    onEdit,
    onCreate,
    onClose,
}) => {
    const { t } = useTranslation('settings');
    return (
        <Dialog open={openWebhook} onOpenChange={onClose}>
            <DialogContent className={d.modal.content}>
                {/* Header */}
                <div className={d.modal.header.container}>
                    <div className={d.modal.header.iconRow}>
                        <div
                            className={`${d.modal.header.iconBox} ${
                                isEdit ? d.modal.header.iconEdit : d.modal.header.iconCreate
                            }`}
                        >
                            <Iconify
                                icon={isEdit ? 'eva:edit-2-outline' : 'eva:plus-outline'}
                                width={18}
                            />
                        </div>
                        <div>
                            <DialogTitle className={d.modal.header.title}>
                                {isEdit
                                    ? t('integrations.make.modal.editTitle', 'Editar credencial')
                                    : t('integrations.make.modal.createTitle', 'Nova credencial')}
                            </DialogTitle>
                            <DialogDescription className={d.modal.header.subtitle}>
                                {isEdit
                                    ? t('integrations.make.modal.editSubtitle', 'Altere os dados da credencial Make')
                                    : t('integrations.make.modal.createSubtitle', 'Configure uma nova credencial para o Make')}
                            </DialogDescription>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className={d.modal.body}>
                    <div className="grid gap-2">
                        <Label htmlFor="nome" className={d.modal.label}>
                            {t('labels.name', { ns: 'common' })}
                        </Label>
                        <Input
                            id="nome"
                            autoFocus
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            placeholder={t('integrations.make.modal.namePlaceholder', 'Ex: Integração CRM')}
                            className={d.modal.input}
                        />
                    </div>
                    <div className="grid gap-2">
                        <Label htmlFor="url" className={d.modal.label}>
                            {t('integrations.make.modal.urlLabel', 'URL do Webhook')}
                        </Label>
                        <Input
                            id="url"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="https://hook.make.com/..."
                            className={d.modal.input}
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className={d.modal.footer}>
                    <Button variant="ghost" onClick={onClose}>
                        {t('buttons.cancel', { ns: 'common' })}
                    </Button>
                    <Button
                        onClick={isEdit ? onEdit : onCreate}
                        disabled={loading}
                        className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white"
                    >
                        {isEdit ? t('buttons.saveChanges', { ns: 'common' }) : t('integrations.make.createCredentialButton', 'Criar credencial')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ModalAddMake;
